export const APP_URL = "https://etkinlik.osmangazi.bel.tr";

export const API_URL = `${APP_URL}/api/v1`;

export const TICKET_ROUTES = {
  DETAIL: (id) => `${API_URL}/tickets/detay/${id}`,
  CLOSE: (id, koltukId) => `${API_URL}/tickets/close-ticket/${id}/${koltukId}`,
  ENTRY: (id) => `${API_URL}/tickets/entry/${id}`,
};

export const AUTH_ROUTES = {
  LOGIN: `${API_URL}/login`,
};
